export default "__VITE_ASSET__0ac5977c__"